<template>
  <InputFieldForm
    :id="id"
    :label="label"
    :class="formClass"
    :required="isRequired"
    :validation-message="errors[0]"
    :label-hidded="labelHidden"
    :icon="icon"
  >
    <textarea
      v-if="!readonly"
      :id="id"
      ref="textAreaElement"
      v-model="model"
      class="form-control"
      :aria-invalid="errors[0] ? errors[0] : undefined"
      :aria-describedby="validationSpanId"
      v-bind="$attrs"
    />
    <span
      v-else
      class="form-control form-control-readonly"
    >
      {{ model }}
    </span>
  </InputFieldForm>
</template>

<script lang="ts" setup>
import InputFieldForm from '@/VueComponents/SharedComponents/InputFields/InputFieldForm.vue';
import InputFieldElementIdGenerator from '@/VueComponents/SharedComponents/InputFields/utils/inputFieldElementIdGenerator';
import ValidationRules from '@/Types/Validation/validationRules';
import { useField } from 'vee-validate';
import { computed, ref } from 'vue';

defineOptions({
  inheritAttrs: false
});

const props = withDefaults(defineProps<{
  id: string,
  label?: string,
  formClass?: string,
  labelHidden?: boolean,
  readonly?: boolean,
  icon?: string,
  validationRules?: ValidationRules
}>(), { label: undefined, validationMessage: undefined, validationRules: undefined,
  icon: undefined, formClass: undefined });

if (!props.id) {
  console.error(`Unique 'id' should be provided.`);
}

const isRequired = computed(() => !!props.validationRules?.required);

const textAreaElement = ref<HTMLElement>();

const validationSpanId = InputFieldElementIdGenerator.getValidationMessageId(props.id);

const model = defineModel<string>();

const dynamicRules = computed(() => props.validationRules);
const { errors, validate } = useField(props.id, dynamicRules, { syncVModel: true });

async function isValid() {
  const result = await validate();
  return result.valid;
}

function focus() {
  textAreaElement.value?.focus();
}

defineExpose({
  isValid,
  focus
});
</script>
